// extracted by mini-css-extract-plugin
var _1 = "BirdviewControl-modulecontrol__H9IQP";
export { _1 as "control" }
